import { connect } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import DateUtils from "src/services/utils/DateUtils";

const FilteringComponent = ({
    onChange
}) => {
    const [tableFilters, setTableFilters] = useState({
        created_from: null,
        created_to: null,
        supplier_name: null
    });

    const dateUtils = new DateUtils();

    const tableFilterTabs = useMemo(() => {
        let filtersList = [
            {
                type: 'date',
                name: 'filter-date',
                title: 'Creation Date',
                icon: <i className="ri-calendar-event-line" />,
                defaultValue: {
                    from: tableFilters['created_from'],
                    to: tableFilters['created_to']
                }
            },
            {
                type: 'search_textbox',
                name: 'supplier_name',
                title: 'Search by third party name',
                icon: <i className="ri-search-2-line" />,
                defaultValue: tableFilters?.supplier_name,
                options: {
                    placeholder: 'Search by third party name',
                    typingDelay: 750
                },
                displayIndependently: true,
                onFilterChange: (value) => {
                    setTableFilters((currentState) => ({ ...currentState, supplier_name: value }))
                }
            }
        ];

        return filtersList
    }, [
        tableFilters
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {}

            if ('filter-date' in filters) {
                result['created_from'] = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.from),
                    'YYYY-MM-DD'
                )

                result['created_to'] = dateUtils.convertDateToDate(
                    new Date(filters['filter-date']?.to),
                    'YYYY-MM-DD'
                )
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                'created_from': null,
                'created_to': null,
                supplier_name: independentTabsData?.supplier_name
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [tableFilters]);

    return (
        <TableFilter
            className="me-2 compliance-screening-filter"
            defaultActiveTab='filter-date'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

const mapStateToProps = (state) => {
    return {
        modules: state.Modules
    };
};

export default withNamespaces()(connect(mapStateToProps, null)(
    FilteringComponent
));
